module.exports = __webpack_public_path__ + "static/img/function-box-img5.99a0b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img5.png
// module id = +Hfh
// module chunks = 0